var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disabled-monetary-display"},[_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.value)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }